import { ISelectOption } from "src/app/interfaces/components/select.interface";

export const contactsTypeOptions: ISelectOption[] = [
  { label: 'PEOPLE_FORM.FORM.CONTACTS.TYPE_SELECT.OPTIONS.PHONE', value: 'phone' },
  { label: 'PEOPLE_FORM.FORM.CONTACTS.TYPE_SELECT.OPTIONS.CELL_PHONE', value: 'cell_phone' },
  { label: 'PEOPLE_FORM.FORM.CONTACTS.TYPE_SELECT.OPTIONS.FAX', value: 'fax' },
  { label: 'PEOPLE_FORM.FORM.CONTACTS.TYPE_SELECT.OPTIONS.OTHER', value: 'other' },
];
